//import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import { ApolloProvider } from '@apollo/client';

import App from './App';
import { store } from './store';
import { NotificationProvider } from './Notification/NotificationContext';

// Debug deployment version
declare const __BUILD_TIME__: string;
declare const __BUILD_HASH__: string;
console.log('🚀 App Build Info:', {
  buildTime: __BUILD_TIME__,
  buildHash: __BUILD_HASH__,
  env: import.meta.env.MODE
});
import { ConfirmProvider } from './Notification/ConfirmContext';

// ⬇️ default export from your file
import client from './graphql/client';

import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
  <ApolloProvider client={client}>
    <Provider store={store}>
      <NotificationProvider>
        <ConfirmProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>

          {/* one global toaster */}
          <Toaster position="top-center" toastOptions={{ style: { borderRadius: '16px' } }} />
        </ConfirmProvider>
      </NotificationProvider>
    </Provider>
  </ApolloProvider>
  // </React.StrictMode>
);
